import React from "react";
import { Box, Divider, Typography, Modal, IconButton } from "@mui/material";
import Grid from "@mui/system/Grid";
import { flexAllCentre, flexAllEnd } from "../../../styles/mui/styles/display";

import { ConfirmationModalBox, ConfirmationModalGrid, ModalGrid } from "../style/style";
import {
  ButtonCloseStyle,
  ButtonVerifyStyle,
  FaXmarkIcon,
  HorizontalDivider,
} from "../../../app/styles/styles";
import { ButtonContained } from "../../../app/common/button";
import fontWeight from "../../../styles/mui/fontWeight";
import { fileModalIconStyle, fileModalStyle } from "../../CreatePriorAuth/style/style";
import { ListOptions } from "../../../models/Master";

export interface PropsFromState {
  open: boolean;
  selectedAgencies: ListOptions[];
  onClose: () => void;
  onConfirm: () => void;
}

const AgencyConfirmationModal: React.FC<any> = ({
  open,
  selectedAgencies,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
      sx={flexAllCentre}
    >
      <Box sx={ConfirmationModalBox}>
        <Grid container sx={ConfirmationModalGrid} >
          <Grid size={{ xs: 11.5 }}>
            <Typography
              id="confirmation-modal-title"
              fontWeight={fontWeight[6]}
              variant="h3"
            >
              Kindly confirm the agencies selected to assign.
            </Typography>
          </Grid>
          <Grid size={{ xs: 0.5 }}>
            <IconButton onClick={onClose}>
              <FaXmarkIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Divider sx={HorizontalDivider} />
        <Box sx={{ ...ModalGrid, maxHeight: "50vh", overflowY: "auto" }}>
          {selectedAgencies.map((agency: ListOptions) => (
            <Typography
              key={agency.value}
              variant="h5"
              fontWeight={fontWeight[4]}
              sx={fileModalStyle}
            >
              <Box component="span" sx={fileModalIconStyle}>
                •
              </Box>
              {agency.label}
            </Typography>
          ))}
        </Box>
        <Divider sx={HorizontalDivider} />
        <Grid container sx={ModalGrid}>
          <Grid size={{ xs: 12 }} sx={flexAllEnd}>
            <ButtonContained
              id="btnSubmit"
              onClick={onConfirm}
              label="Yes"
              disabled={false}
              style={ButtonVerifyStyle}
            />
            <ButtonContained
              id="btnClose"
              onClick={onClose}
              label="No"
              disabled={false}
              style={ButtonCloseStyle}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AgencyConfirmationModal;
